import i18n from 'i18next'
import React, { createContext } from 'react'

import { ActionType } from '~filtersReducer'
import { FilterType } from '~types/filters'
import { BuyStatus } from '~types/offer'
import createGenericContext from '~utils/createGenericContext'

export type CategoryType = FilterType & { isChecked: boolean }
export type CategoriesListType = CategoryType[]
export type CoinRangeType = {
  from: string
  to: string
}
export type LocationType = FilterType
export type OfferStatus = FilterType

export type FiltersStateType = {
  categoriesList: CategoriesListType
  coinRange: CoinRangeType
  selectedLocation: LocationType
  selectedOfferStatus: OfferStatus
}

export type FilterContextType = {
  filtersDispatch: React.Dispatch<ActionType>
  offersStatusList: OfferStatus[]
  filtersState: FiltersStateType
}

export const offersStatusList: OfferStatus[] = [
  { label: i18n.t('offers_list_screen.redeemed'), value: BuyStatus.REDEEMED.toString() },
  { label: i18n.t('offers_list_screen.not_redeemed'), value: BuyStatus.NOT_REDEEMED.toString() },
  { label: i18n.t('offers_list_screen.all'), value: '' },
]

export const initPickerValue: FilterType = { label: '', value: '' }
export const initCoinRange: CoinRangeType = { from: '', to: '' }
export const initialFiltersState: FiltersStateType = {
  categoriesList: [],
  coinRange: initCoinRange,
  selectedLocation: initPickerValue,
  selectedOfferStatus: initPickerValue,
}

export const FiltersContext = createContext<FilterContextType>({
  filtersDispatch: () => undefined,
  offersStatusList,
  filtersState: initialFiltersState,
})

export const [useFiltersContext, FiltersContextProvider] =
  createGenericContext<FilterContextType>('FiltersContext')
